export const CREATE_CANDIDATE = "/create/candidate/json?";
export const INVITE_CANDIDATE = "/candidate/invite/json?";
export const CANDIDATE_DETAILS = "/candidate/talentMap/json?";
export const PENDING_ASSESSMENT = "/assessment/pending/json?";
export const ASSESSMENT_DETAILS = "/report/factors_scores/json?";
